module.exports = __webpack_public_path__ + "static/media/file_guide.0a4a81c6.png";